<template>
  <div class="nav">
  	<div class="nav-company">
  		<div class="nav-company-box">
  			<p class="nav-company-title">{{customName}}</p>
  			<p class="nav-company-info">微信客服工作台</p>
  		</div>
  	</div>
  	<div class="nav-items">
  		<div class="nav-item-wrap">
  			<div class="nav-item" :class="{'nav-item-active':activeTab=='chat'}" @click="changeTab('chat')">
  				<div class="nav-item-icon nav-item-icon-chat"></div>
  				<div class="nav-item-title">聊天中心</div>
  			</div>
  			<div class="nav-item" :class="{'nav-item-active':activeTab=='history'}" @click="changeTab('history')">
  				<div class="nav-item-icon nav-item-icon-history"></div>
  				<div class="nav-item-title">历史记录</div>
  			</div>
  			<div class="nav-item" :class="{'nav-item-active':activeTab=='circle'}" @click="changeTab('circle')">
  				<div class="nav-item-icon nav-item-icon-circle"></div>
  				<div class="nav-item-title">朋友圈</div>
				<div class="nav-item-new" v-if="mReplyList.length > 0"></div>
  			</div>
  			<div class="nav-item" :class="{'nav-item-active':activeTab=='work'}" @click="changeTab('work')">
  				<div class="nav-item-icon nav-item-icon-work"></div>
  				<div class="nav-item-title">业绩</div>
  			</div>
  			<div class="nav-item" :class="{'nav-item-active':activeTab=='help'}" @click="changeTab('help')">
  				<div class="nav-item-icon nav-item-icon-help"></div>
  				<div class="nav-item-title">帮助中心</div>
  			</div>
  		</div>
  	</div>
  	<div class="nav-user">
  		<div class="nav-user-wrap">
  			<div class="nav-msg-notice">
  				<img src="./../../assets/img/nav-notice.png" alt="">
  				<div class="nav-msg-new" v-if="noticeList.length > 0"></div>
  			</div>
  			<div class="nav-user-icon">
  				<img src="./../../assets/img/nav-user.png" alt="">
  			</div>
  			<div class="nav-user-name" :title="loginInfo.name">
  				<p>{{loginInfo.name}}</p>
  			</div>
			<div class="nav-user-status" :class="{'nav-user-status-outline' : managerStatus === 0}"></div>
  			<div class="nav-user-tool">
  				<span class="nav-user-tool-icon" :class="{'nav-user-tool-icon-up':upIcon}" @click="userToolClick"></span>
  			</div>
  		</div>
  		<div class="nav-user-menu" v-if="upIcon">
  			<!-- <div class="nav-user-menu-item">
  				<span class="nav-user-mi-icon nav-user-mi-modify"></span>
  				<span class="nav-user-mi-text">修改信息</span>
  			</div> -->
  			<div class="nav-user-menu-item">
  				<span class="nav-user-mi-icon nav-user-mi-online"></span>
  				<span class="nav-user-mi-text" @click="modifyMStatus(1)">客服在线</span>
  			</div>
  			<div class="nav-user-menu-item">
  				<span class="nav-user-mi-icon nav-user-mi-outline"></span>
  				<span class="nav-user-mi-text" @click="modifyMStatus(0)">客服离线</span>
  			</div>
  			<div class="nav-user-menu-item" @click="logout">
  				<span class="nav-user-mi-icon nav-user-mi-logout"></span>
  				<span class="nav-user-mi-text">退出登录</span>
  			</div>
  		</div>
		<div class="nav-msg-list" v-if="noticeList.length > 0">
			<div v-for="(msg,index) in noticeList" class="nav-msg-item-wrap">
				<div class="nav-msg-item" v-if="noticeOpen || (!noticeOpen && index < 5)"
					:key="'nav-notice-'+(100000-index)" 
					:class="{'nav-msg-item-animation': index === 0 ? msgAnimation : false}" 
					@click="jump(index)">
						<div class="nav-msg-title">
							<span class="nav-msg-title-icon"></span>
							<span class="nav-msg-title-text">收到【{{msg.from_name}}】的消息：</span>
						</div>
						<div class="nav-msg-text">{{msg.content | formatRMsg(msg.type)}}</div>
						<div class="nav-msg-jump">请点击查看</div>
						<div class="nav-msg-close" @click="closeNotice(index)">X</div>
				</div>
			</div>
			<div class="nav-msg-more" v-if="noticeList.length > 5">
				<span v-if="!noticeOpen" @click="noticeOpen = true">所有消息（{{noticeList.length}}）⬇</span>
				<span v-else @click="noticeOpen = false">收起消息（{{noticeList.length}}）⬆</span>
			</div>
		</div>
		<audio src="/voice/remind.mp3" style="display: none;" id="notice-audio"></audio>
  	</div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {getLocalConfig,formatTimeToYMDHms} from '../../functions/Common.js'
import {getRecentlyByFIdAndType,getRecentlyById} from '../../network/local/recently.js'
import {webGetFansTransferByFansId} from '../../network/web/manager.js'
import {saveTransferData} from '../../network/local/fans-transfer.js'
	
export default {
	name:"NavHome",
	data(){
		return {
			activeTab: 'chat',
			upIcon: false,
			customName: '畅聊',
			noticeList:[],
			msgAnimation: false,
			noticeOpen: false
		}
	},
	methods:{
		// 菜单切换
		changeTab(tab){
			this.activeTab = tab
			let path = '/chat/chat'
			switch (tab){
				case 'chat':
					path = '/chat/chat'
					break;
				case 'history':
					path = '/history/home'
					break;
				case 'circle':
					path = '/circle/home'
					break;
				case 'work':
					path = '/work/home'
					break;
				case 'help':
					path = '/help/home'
					break;
			}
			if(this.$route.path != path){
				this.$router.push(path)
			}
		},
		
		// 用户上下三角点击
		userToolClick(){
			this.upIcon = !this.upIcon;
		},
		
		// 退出登录
		logout(){
			localStorage.removeItem('imLoginInfo')
			this.upIcon = false
			this.$store.commit('saveLoginInfo',{
				id:0,
				name:''
			})
			this.$router.push('/login/login')
		},
		
		// 关闭通知
		closeNotice(index){
			this.noticeList.splice(index,1)
		},
		
		// 通知点击查看
		jump(index){
			let chatUser = this.noticeList[index]
			this.noticeList.splice(index,1)
			if(chatUser.is_special === true){
				let data = {
					type: 'pageNotice',
					info:{
						nType: 'noRead',
						fansId: chatUser.fans_id,
						chatType: chatUser.chatType,
						type: 'recently'
					}
				}
				this.$store.commit('updateOtherEvent',data)
			}else{
				let query = {
					fansId: chatUser.fans_id,
					chatType: chatUser.chatType,
					type: 'recently'
				}
				this.activeTab = 'chat'
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			}
		},
		
		// 状态修改
		modifyMStatus(val){
			this.$store.commit('updatemManagerStatus',val)
			this.upIcon = false
		},
		
		// 追加消息
		mergeMsg(msg){
			if(msg.expireTime === undefined){
				msg.expireTime = new Date().getTime() + 10000
			}
			this.msgAnimation = false
			/* if(this.noticeList.length >= 5){
				this.noticeList.splice(this.noticeList.length-1,1)
				this.noticeList.unshift(msg)
			}else{
				this.noticeList.unshift(msg)
			} */
			this.noticeList.unshift(msg)
			setTimeout(()=>{
				this.msgAnimation = true
			},100)
		}
	},
	
	computed:{
		// 获取登录状态信息
		loginInfo(){
			return this.$store.state.loginInfo
		},
		
		// 计算消息提醒列表显隐
		currentMsg(){
			return this.$store.state.currentChatMsg
		},
		
		// 监听vuex中的评论列表
		mReplyList(){
			return this.$store.state.mReply
		},
		
		// 获取vuex中的管理员在线状态
		managerStatus(){
			return this.$store.state.managerStatus
		},
		
		// 获取vuex中的事件
		otherEvent(){
			return this.$store.state.otherEvent
		}
	},
	
	watch:{
		// 监听新的消息，
		currentMsg(nVal){
			if(nVal.is_me !== undefined && nVal.is_me === 0){
				// 提示音播放
				let newMsgMusic = getLocalConfig('newMsgMusic')
				if(newMsgMusic === null || newMsgMusic === true){
					if(nVal.chatType !== undefined && nVal.fans_id !== undefined){
						if(nVal.recentlyId !== undefined){
							getRecentlyById(nVal.recentlyId,data=>{
								if(data === false){
									document.getElementById("notice-audio").play()
								}else{
									if(data.no_disturb === undefined || data.no_disturb !== 1){
										document.getElementById("notice-audio").play()
									}
								}
							})
						}else{
							getRecentlyByFIdAndType(nVal.fans_id,nVal.chatType,data=>{
								if(data === false){
									document.getElementById("notice-audio").play()
								}else{
									if(data.no_disturb === undefined || data.no_disturb !== 1){
										document.getElementById("notice-audio").play()
									}
								}
							})
						}
					}
				}
				
				// 同志消息显示
				let path = this.$route.path
				let urls = path.split('/')
				if(urls.length !== 3 || urls[2] === 'chat'){
					return
				}
				nVal = JSON.parse(JSON.stringify(nVal))
				this.mergeMsg(nVal)
			}
		},
		
		// 监听路由变化
		'$route.path'(nVal){
			let path = nVal.split('/')
			this.activeTab = path[1]
		},
		
		// 监听事件变化
		otherEvent(nVal){
			// 未读消息提示
			if(nVal.type !== undefined){
				if(nVal.type === 'remind'){
					let msg = {
						from_name: '系统提示',
						content: '您有一个客户未回复：'+nVal['fans_name'] + '，'+formatTimeToYMDHms((new Date()).getTime()),
						type: 'text',
						fans_id: nVal.friend_id,
						custom_id:nVal.custom_id,
						chatType: 1,
						is_special: true,
						expireTime: new Date().getTime() + 1000 * 3600 * 24
					}
					this.mergeMsg(msg)
				}else if(nVal.type === 'transfer_fans'){
					if(nVal.toOrg == 1){
						let msg = {
							from_name: '系统提示',
							content: '您有一个会话转移（转回自己）！',
							type: 'text',
							fans_id: nVal.fansId,
							custom_id:nVal.customId,
							chatType: 1,
							is_special: true,
							expireTime: new Date().getTime() + 1000 * 3600 * 24
						}
						this.mergeMsg(msg)
					}else{
						webGetFansTransferByFansId(nVal.fansId,(data)=>{
							saveTransferData(data.data,()=>{
								let msg = {
									from_name: '系统提示',
									content: '您有一个会话转移！',
									type: 'text',
									fans_id: nVal.fansId,
									custom_id:nVal.customId,
									chatType: 1,
									to_org:nVal.toOrg,
									is_special: true,
									expireTime: new Date().getTime() + 1000 * 3600 * 24
								}
								this.mergeMsg(msg)
							})
						})
					}
				}
			}
		}
	},
	
	created() {
	  let path = this.$route.path
	  let urls = path.split('/')
	  this.activeTab = urls[1]
	  
	  // 定时删除通知消息
	  setInterval(()=>{
		  let data = JSON.parse(JSON.stringify( this.noticeList))
		  for (let i = 0; i < data.length; i++) {
			if(data[i].expireTime < new Date().getTime()){
				this.noticeList.splice(i,1)
			}
		  }
	  },1000)
	}
}
</script>
<style>
.top-0{
	top: 0 !important;
}
.nav{
	background-color: #2C3E50;
	height: 80px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	color: #FFFFFF;
	user-select: none;
}
.nav .nav-company{
	width: 480px;
	height: 80px;
	position: absolute;
	left: 0;
	top: 0;
}
.nav-company .nav-company-box{
	width: 400px;
	margin-left: 80px;
	padding: 15px 0;
	line-height: 25px;
}
.nav-company-box .nav-company-title{
	font-size: 16px;
	font-weight: 600;
}
.nav .nav-items{
	height: 80px;
	position: absolute;
	top: 0;
	left: 480px;
	right: 260px;
	text-align: center;
}
.nav-items .nav-item-wrap{
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	align-content: center;
	flex-direction: row;
	flex-wrap: nowrap;
}
.nav-item-wrap .nav-item-active{
	border-bottom: #42B983 3px solid;
}
.nav-item-wrap .nav-item{
	width: 80px;
	height: 80px;
	padding: 10px 0;
	margin: 0 10px;
	cursor: pointer;
	box-sizing: border-box;
	position: relative;
}
.nav-item .nav-item-icon{
	width: 26px;
	height: 26px;
	margin-left: 25px;
	background-position:center;
	background-size: cover;
}
.nav-item .nav-item-icon-chat{
	background-image: url(../../assets/img/nav-chat.png);
}
.nav-item .nav-item-icon-history{
	background-image: url(../../assets/img/nav-history.png);
}
.nav-item .nav-item-icon-circle{
	background-image: url(../../assets/img/nav-circle.png);
}
.nav-item .nav-item-icon-work{
	background-image: url(../../assets/img/nav-work.png);
}
.nav-item .nav-item-icon-help{
	background-image: url(../../assets/img/nav-help.png);
}
.nav-item-active .nav-item-icon-chat{
	background-image: url(../../assets/img/nav-chat-acitve.png) !important;
}
.nav-item-active .nav-item-icon-history{
	background-image: url(../../assets/img/nav-history-active.png) !important;
}
.nav-item-active .nav-item-icon-circle{
	background-image: url(../../assets/img/nav-circle-active.png) !important;
}
.nav-item-active .nav-item-icon-work{
	background-image: url(../../assets/img/nav-work-active.png) !important;
}
.nav-item-active .nav-item-icon-help{
	background-image: url(../../assets/img/nav-help-active.png) !important;
}
.nav-item .nav-item-title{
	margin-top: 4px;
	line-height: 30px;
}
.nav-item-active .nav-item-title{
	color: #42B983;
}
.nav-item .nav-item-new{
	position: absolute;
	top: 8px;
	right: 26px;
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background-color: red;
}
.nav .nav-user{
	width: 240px;
	height: 80px;
	position: absolute;
	top: 0;
	right: 20px;
}
.nav-user .nav-user-wrap{
	width: 100%;
	height: 5rem;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	align-content: center;
	flex-direction: row;
	flex-wrap: nowrap;
}
.nav-user-wrap .nav-msg-notice{
	width: 60px;
	height: 80px;
	position: relative;
	cursor: pointer;
}
.nav-msg-notice img{
	width: 30px;
	height: auto;
	margin-top: 25px;
	margin-left: 15px;
}
.nav-msg-notice .nav-msg-new{
	width: 10px;
	height: 10px;
	border-radius: 5px;
	position: absolute;
	top: 15px;
	right: 5px;
	animation: nav-msg-new 1s ease-in-out infinite reverse;
	background-color: red;
}
@keyframes nav-msg-new{
	from{
		opacity: 0;
	}
	to{
		opacity: 1;
	}
}
.nav-user-wrap .nav-user-icon{
	width: 40px;
	height: 80px;
}
.nav-user-wrap .nav-user-icon img{
	width: 30px;
	height: auto;
	margin-top: 25px;
	margin-left: 5px;
}
.nav-user-wrap .nav-user-name{
	max-width: 100px;
	min-width: 40px;
	height: 80px;
	line-height: 80px;
	text-align: left;
	margin-left: 5px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.nav-user-wrap .nav-user-status{
	width: 16px;
	height: 16px;
	margin-left: 5px;
	background-image: url(../../assets/img/online.png);
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}
.nav-user-wrap .nav-user-status-outline{
	background-image: url(../../assets/img/outline.png) !important;
}
.nav-user-wrap .nav-user-tool{
	width: 20px;
	line-height: 20px;
	margin-left: 5px;
	cursor: pointer;
}
.nav-user-tool .nav-user-tool-icon{
	width: 20px;
	height: 20px;
	display: block;
	background-image: url(../../assets/img/nav-down-triangle.png);
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}
.nav-user-tool .nav-user-tool-icon-up{
	background-image: url(../../assets/img/nav-up-triangle.png) !important;
}
.nav-user .nav-user-menu{
	position: absolute;
	width: 120px;
	height: auto;
	z-index: 10;
	right: -10px;
	top: 60px;
	background-color: #e4e4e4;
	padding: 10px 20px;
	border-radius: 2px;
	color: #666666;
}
.nav-user-menu::after{
	content: '';
	display: block;
	position: absolute;
	top: -5px;
	right: 14px;
	width: 10px;
	height: 10px;
	background-color: #e4e4e4;
	transform: rotateZ(45deg);
}
.nav-user-menu-item{
	height: 32px;
	line-height: 32px;
	cursor: pointer;
}
.nav-user-menu-item span{
	display: inline-block;
	vertical-align: middle;
}
.nav-user-menu-item .nav-user-mi-icon{
	width: 18px;
	height: 18px;
	background-position: center;
	background-size: 18px auto;
	margin-right: 10px;
}
.nav-user-mi-modify{
	background-image: url(../../assets/img/modify.png);
}
.nav-user-mi-online{
	background-image: url(../../assets/img/online.png);
}
.nav-user-mi-outline{
	background-image: url(../../assets/img/outline.png);
}
.nav-user-mi-logout{
	background-image: url(../../assets/img/logout-red.png);
}
.nav-user .nav-msg-list{
	position: absolute;
	padding: 0 5px;
	background-color: #00000000;
	top: 60px;
	right: 0px;
	z-index: 101;
	min-height: 100px;
	max-height: 500px;
	color: #E6E6E6;
	overflow-x: hidden;
	overflow-y: auto;
}
.nav-msg-list .nav-msg-item{
	background-color: #ef6542;
	padding: 10px;
	margin: 10px 0;
	min-height: 50px;
	border-radius: 2px;
	position: relative;
	cursor: pointer;
	width: 240px;
	box-sizing: border-box;
}
.nav-msg-list .nav-msg-more{
	color: #FFFFFF;
	font-size: 12px;
	text-align: center;
	cursor: pointer;
	user-select: none;
	background: #e7886f;
	padding: 5px 0;
}
.nav-msg-list .nav-msg-item-wrap::first-line .nav-msg-item{
	opacity: 0.1;
}
.nav-msg-list .nav-msg-item-animation{
	animation: nav-msg-add 1s ease-in-out 1;
	 animation-fill-mode: forwards;
}
@keyframes nav-msg-add{
	from{
		opacity: 0.1;
	}
	to{
		opacity: 1;
	}
}
.nav-msg-item .nav-msg-title{
	height: 24px;
	line-height: 24px;
	overflow: hidden;
	white-space: nowrap;
	font-size: 12px;
}
.nav-msg-title > span{
	display: inline-block;
	vertical-align: middle;
}
.nav-msg-title .nav-msg-title-icon{
	width: 16px;
	height: 16px;
	background-image: url(../../assets/img/msg-e6-32.png);
	background-position: center;
	background-size: 16px auto;
	background-repeat: no-repeat;
	margin-right: 2px;
}
.nav-msg-item .nav-msg-text{
	font-size: 12px;
	line-height: 20px;
	max-height: 40px;
	overflow: hidden;
}
.nav-msg-item .nav-msg-jump{
	font-size: 12px;
	cursor: pointer;
}
.nav-msg-item .nav-msg-close{
	position: absolute;
	width: 16px;
	height: 16px;
	line-height: 16px;
	top: 2px;
	right: 5px;
	cursor: pointer;
	text-align: center;
}
</style>
